import * as gfunctions from '../../../js/generalFunctions';

CCL.cruiseManager = {
  autoload: [
    ['load', $('.c-cruise-manager').length > 0],
    ['removeOverlapAndEnableSticky', $('#todoPlanner').length > 0]
    //  ['carousel2', $('.owl-carousel-2').length > 0],
    // ['bulletsContext', $('.owl-carousel-2').length > 0]
  ],

  customData: {},
  loadedCarousel: [],
  allCarouselData: [],
  isCurrentVibeLoaded: false,

  load() {
    this.loadVibeCarousels();
  },

  getAllCategories() {
    const categoriesList = [];
    $('.cruisemanager-vibes').each((index, element) => {
      const currentVibeObj = {
        categoryCode: element.dataset.categorycode,
        categoryName: element.dataset.categoryname,
        componentUid: element.id,
        coloumnGridStyle: element.dataset.coloumngridstyle
      };
      categoriesList.push(currentVibeObj);
    });
    return categoriesList;
  },

  async loadVibeCarousels() {
    try {
      const allCategories = await this.getAllCategories();
      for (let i = 0; i < allCategories.length; i++) {
        this.loadCarouselData(allCategories[i].categoryCode, allCategories[i].componentUid, true);
      }
    } catch (err) {
      const LoadCarouselError = { replaceHTMLError: err };
      console.log(LoadCarouselError);
    }
  },

  sortDropDownLabels(completeData) {
    let beforeData = [];
    beforeData = completeData.vibeDropdown.dropdownItems;
    beforeData.sort((a, b) => {
      return a.label === b.label ? 0 : +(a.label > b.label) || -1;
    });
    completeData.vibeDropdown.dropdownItems = beforeData;
    return completeData;
  },

  async loadCarouselData(carouselId, componentUid, isHtmlEvents) {
    let ajaxUrl = '';
    if (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') {
      ajaxUrl = `/_ui/responsive/ccl/assets/templates/vibe-dropdown/vibe-dropdown-${componentUid}.json`;
    } else {
      ajaxUrl = `/shop/cclcategoryvibes/fetchProducts?componentUid=${componentUid}&categoryCode=${carouselId}`;
    }
    try {
      const inputDataObj = {
        url: ajaxUrl,
        type: 'GET',
        cache: false
      };
      let res = await gfunctions.doAjax(inputDataObj);
      if (res) {
        if (res.vibeDropdown && res.vibeDropdown.dropdownItems.length) {
          let filledStars = [];
          let emptyStars = [];
          let splitRating = [];
          let tempEmpty = [];
          const totalReviews = 5;
          let emptyRating = 0;
          res.vibeDropdown.dropdownItems.forEach(element => {
            element.productsCarousel.products.forEach(productElement => {
              emptyRating = 0;
              if (productElement.productAverageRating) {
                filledStars = [];
                emptyStars = [];
                splitRating = Number(productElement.productAverageRating).toFixed(1).split('.');
                for (let index = 0; index < Number(splitRating[0]); index++) {
                  filledStars.push({ ratingStars: '/_ui/responsive/ccl/assets/icons/star_filled.svg' });
                }
                if (Number(splitRating[1]) === 5) {
                  filledStars.push({ ratingStars: '/_ui/responsive/ccl/assets/icons/starhalf.svg' });
                } else if (Number(splitRating[1]) > 5) {
                  filledStars.push({ ratingStars: '/_ui/responsive/ccl/assets/icons/star_filled.svg' });
                } else if (Number(splitRating[1]) < 5 && Number(splitRating[1]) !== 0) {
                  filledStars.push({ ratingStars: '/_ui/responsive/ccl/assets/icons/star_empty.svg' });
                }
                productElement.emptyRating = totalReviews - productElement.productAverageRating;
                emptyRating = productElement[emptyRating];
                productElement.filledStars = filledStars;
                tempEmpty = Number(productElement.emptyRating).toFixed(1).split('.');

                for (let idx = 0; idx < Number(tempEmpty[0]); idx++) {
                  emptyStars.push({ emptyStars: '/_ui/responsive/ccl/assets/icons/star_empty.svg' });
                }
                productElement.emptyStars = emptyStars;
              }
            });
          });
          if (res.vibeDropdown.dropdownItems[0].productsCarousel.products.length) {
            res = this.modifyCurrentCategoryJSON(res, componentUid);
            sessionStorage.setItem('allCarouselData', JSON.stringify(res));
            this.allCarouselData.push(res);
            this.customData.allData = res;
            this.customData.allData.haveVibes = this.customData.allData.vibeDropdown.dropdownItems.length > 0;
            this.customData.activeData = res.vibeDropdown.dropdownItems.filter((x) => x.active)[0].productsCarousel;
            if (this.customData.activeData.type === 'owl-carousel') {
              this.customData.activeData.isSingleCarousel = true;
            } else {
              this.customData.activeData.isSingleCarousel = false;
            }
            if ($('#lazyLoadingEnabled').data('enabled') === 'true' || $('#lazyLoadingEnabled').data('enabled') === true) {
              this.customData.activeData.lazyLoadingEnabled = true;
            } else {
              this.customData.activeData.lazyLoadingEnabled = false;
            }
            this.loadHtml(this.customData, isHtmlEvents);
            this.customData = {};
          }
        }
      }
    } catch (err) {
      const LoadCarouselError = { replaceHTMLError: err };
      console.log(LoadCarouselError);
    }
  },

  modifyCurrentCategoryJSON(jsonData, componentUid) {
    const modifiedJSON = jsonData;
    const newProductsCarousel = modifiedJSON.vibeDropdown.dropdownItems[0].productsCarousel;
    let vibeType = '';
    let changeAtcClass = '';
    const changedProductsCarousel = this.changeCurrentCarouselType(newProductsCarousel);
    const carouselLength = modifiedJSON.vibeDropdown.dropdownItems;
    for (let i = 0; i < carouselLength.length; i++) {
      for (let j = 0; j < carouselLength[i].productsCarousel.products.length; j++) {
        vibeType = carouselLength[i].productsCarousel.products[j].vibeProductType;
        if (carouselLength[i].productsCarousel.products[j].strikeOutPrice === null) {
          carouselLength[i].productsCarousel.products[j].strikeOutPrice = '';
        }
        if (carouselLength[i].productsCarousel.products[j].childStrikeOutPrice === null) {
          carouselLength[i].productsCarousel.products[j].childStrikeOutPrice = '';
        }
        changeAtcClass = this.addToCartClass(vibeType);
        carouselLength[i].productsCarousel.products[j].addToCartClass = changeAtcClass;
      }
    }

    modifiedJSON.vibeDropdown.dropdownItems[0].productsCarousel = changedProductsCarousel;
    modifiedJSON.componentUid = componentUid;
    return modifiedJSON;
  },

  addToCartClass(vibeType) {
    let addToCartClass = '';
    switch (vibeType) {
      case 'EX':
        addToCartClass = 'checkoutConflictBtn';
        break;
      case 'SP':
        addToCartClass = 'calendarOpenBtn';
        break;
      case 'CHEERS': case 'BUBBLES': case 'INTERNET': case 'FTTF': {
        addToCartClass = 'clp-add-to-cart-btn';
        break;
      }
      case 'SFP': case 'SFAP': case 'SF': {
        addToCartClass = 'alcohol-atc-modal-open-button';
        break;
      }
      case 'FS':
        addToCartClass = 'btn-add-cart';
        break;
      default:
        addToCartClass = 'btn-add-cart';
        break;
    }
    return addToCartClass;
  },

  changeCurrentCarouselType(changeProductsCarousel) {
    switch (Number(changeProductsCarousel.type)) {
      case 1:
        changeProductsCarousel.type = 'owl-carousel';
        break;
      case 2:
        changeProductsCarousel.type = 'owl-carousel-2';
        break;
      case 3:
        changeProductsCarousel.type = 'owl-carousel-3';
        break;
      case 4:
        changeProductsCarousel.type = 'owl-carousel-4';
        break;
      default:
        changeProductsCarousel.type = changeProductsCarousel.type;
        break;
    }
    return changeProductsCarousel;
  },

  clickEventsOnHtml() {
    $(document.body).on('click keypress', '.vibe-item', (e) => {
      if (e.type === 'click' || e.keyCode === 13) {
        const { currentTarget } = e;
        e.stopImmediatePropagation();
        const id = currentTarget.parentElement.id.split(/-(.+)/)[1];

        $(`#dropdownVal-${id}`)[0].innerText = '';
        $(`#dropdownVal-${id}`)[0].innerText = currentTarget.innerText;
        $('.vibe-item').removeClass('active');
        currentTarget.className += ' active'; // Append active class to selected
        let selectedData = [];
        $.each(this.allCarouselData, (index, value) => {
          value.vibeDropdown.dropdownItems.forEach((element) => {
            element.active = false;
          });
          if (value.componentUid === id) {
            this.customData.allData = value;
            selectedData = value.vibeDropdown.dropdownItems.filter((x) => x.value === currentTarget.dataset.value);
          }
        });
        if (selectedData.length) {
          selectedData[0].active = true;
          this.customData.activeData = this.changeCurrentCarouselType(selectedData[0].productsCarousel);
          if (this.customData.activeData.type === 'owl-carousel') {
            this.customData.activeData.isSingleCarousel = true;
          } else {
            this.customData.activeData.isSingleCarousel = false;
          }
        }
        this.replaceHtml(id, this.customData);
      }
    });
  },

  async loadHtml(jsonData, isHtmlEvents) {
    const replace = 'assets';
    const ajaxUrl = `/_ui/responsive/ccl/${replace}/templates/vibe-dropdown/vibe-dropdown.html`;
    const { componentUid } = jsonData.allData;
    gfunctions.showCustomLoader(componentUid);
    try {
      const inputDataObj = {
        url: ajaxUrl,
        type: 'GET'
      };
      const resp = await gfunctions.doAjax(inputDataObj);
      gfunctions.removeCustomLoader(componentUid);
      const dynamicHtml = gfunctions.createDynamicHTML(resp, jsonData);
      $(`#${componentUid}`).replaceWith(dynamicHtml);
      if (isHtmlEvents) {
        this.clickEventsOnHtml();
        CCL.carousel.carousel3_4Navigation();
        this.bulletsContext();
      }
      this.carouselFunctions(); // Load carousel jquery after bindind html

      // Switch for favorite functionality
      if ($('#isfavoritesEnabled').length) {
        console.dir($('#isfavoritesEnabled'));
        if ($('#isfavoritesEnabled')[0].dataset.enabled === true || $('#isfavoritesEnabled')[0].dataset.enabled === 'true') {
          $('body').find('.fav-section').removeClass('d-none');
        }
      }
    } catch (err) {
      gfunctions.removeCustomLoader(componentUid);
      const VibeAPIError = { replaceHTMLError: err };
      console.log(VibeAPIError);
    }
  },

  async replaceHtml(id, data) {
    gfunctions.showCustomLoader(id);
    const replace = 'assets';
    const ajaxUrl = `/_ui/responsive/ccl/${replace}/templates/vibe-dropdown/vibe-dropdown.html`;
    try {
      const inputDataObj = {
        url: ajaxUrl,
        type: 'GET'
      };
      const newResponse = await gfunctions.doAjax(inputDataObj);
      gfunctions.removeCustomLoader(id);
      const dynamicHtml = gfunctions.createDynamicHTML(newResponse, data);
      $(`#section-${id}`).replaceWith(dynamicHtml);
      this.carouselFunctions(); // Load carousel jquery after binding html
      // Switch for favorite functionality
      if ($('#isfavoritesEnabled').length) {
        console.dir($('#isfavoritesEnabled'));
        if ($('#isfavoritesEnabled')[0].dataset.enabled === true || $('#isfavoritesEnabled')[0].dataset.enabled === 'true') {
          $('body').find('.fav-section').removeClass('d-none');
        }
      }
    } catch (err) {
      gfunctions.removeCustomLoader(id);
      const VibeAPIError = { replaceHTMLError: err };
      console.log(VibeAPIError);
    }
  },

  carouselFunctions() {
    // Lazy load images
    if ($('img.lazy').length) {
      if ($('#lazyLoadingEnabled').data('enabled') === 'true' || $('#lazyLoadingEnabled').data('enabled') === true) {
        CCL.lazyLoadInstance.update();
      }
    }

    $('.owl-carousel-2').owlCarousel({
      loop: false,
      nav: true,
      margin: 16,
      touchDrag: true,
      mouseDrag: true,
      responsiveClass: true,
      navText: ['<i class="fas fa-chevron-left" aria-label="Previous items in the Carousel"></i>', '<i class="fas fa-chevron-right" aria-label="Next items in the Carousel"></i>'],
      responsive: {
        0: {
          items: 1
        },
        768: {
          items: 2
        },
        1024: {
          items: 2
        },
        1200: {
          items: 2
        }
      }
    });

    $('.owl-carousel-3').owlCarousel({
      loop: false,
      nav: true,
      margin: 16,
      touchDrag: true,
      mouseDrag: true,
      responsiveClass: true,
      navText: ['<i class="fas fa-chevron-left" aria-label="Previous items in the Carousel"></i>', '<i class="fas fa-chevron-right" aria-label="Next items in the Carousel"></i>'],
      responsive: {
        0: {
          items: 1
        },
        768: {
          items: 2
        },
        1024: {
          items: 3
        },
        1200: {
          items: 3
        }
      }
    });

    $('.owl-carousel-4').owlCarousel({
      loop: false,
      nav: true,
      margin: 16,
      touchDrag: true,
      mouseDrag: true,
      responsiveClass: true,
      navText: ['<i class="fas fa-chevron-left" aria-label="Previous items in the Carousel"></i>', '<i class="fas fa-chevron-right" aria-label="Next items in the Carousel"></i>'],
      responsive: {
        0: {
          items: 1
        },
        768: {
          items: 2
        },
        1024: {
          items: 3
        },
        1200: {
          items: 4
        }
      }
    });

    $('.owl-carousel-5').owlCarousel({
      loop: false,
      nav: true,
      margin: 16,
      touchDrag: true,
      mouseDrag: true,
      responsiveClass: true,
      navText: ['<i class="fas fa-chevron-left" aria-label="Previous items in the Carousel"></i>', '<i class="fas fa-chevron-right" aria-label="Next items in the Carousel"></i>'],
      responsive: {
        0: {
          items: 1
        },
        768: {
          items: 2
        },
        1024: {
          items: 4
        },
        1200: {
          items: 5
        }
      }
    });

    $('.owl-carousel-6').owlCarousel({
      loop: false,
      nav: true,
      margin: 16,
      touchDrag: true,
      mouseDrag: true,
      responsiveClass: true,
      navText: ['<i class="fas fa-chevron-left" aria-label="Previous items in the Carousel"></i>', '<i class="fas fa-chevron-right" aria-label="Next items in the Carousel"></i>'],
      responsive: {
        0: {
          items: 2
        },
        768: {
          items: 3
        },
        1024: {
          items: 4
        },
        1200: {
          items: 6
        }
      }
    });

    $('.owl-carousel').owlCarousel({
      loop: false,
      nav: true,
      touchDrag: true,
      mouseDrag: true,
      margin: 0,
      items: 1
    });
  },

  removeOverlapAndEnableSticky() {
    $('document').ready(() => {
      if (window.innerWidth < 768) {
        if ($('.overlap-cmp').length > 0) {
          $('.overlap-cmp').each((index1, cmpElement) => {
            $(cmpElement)[0].classList.remove('overlap-cmp');
          });
        }
        if ($('.sticky-wrap').length > 0) {
          $('.sticky-wrap').each((index2, cmpStickyElement) => {
            $(cmpStickyElement)[0].classList.remove('sticky-wrap');
          });
        }
      } else {
        const getTodoPlanner = $('#todoPlanner');
        const parentEl = getTodoPlanner[0].parentElement;
        const nextSiblingEl = parentEl.nextSibling.nextSibling;
        nextSiblingEl.childNodes[1].classList.add('sticky-wrap');
        if (parentEl.nextElementSibling) {
          const nextElementSiblng = parentEl.nextElementSibling.nextElementSibling;
          if (nextElementSiblng.childNodes.length > 1) {
            if (nextElementSiblng.childNodes[1].classList) {
              nextElementSiblng.childNodes[1].classList.add('sticky-wrap');
            }
          }
        }
      }
    });
  },

  calculatePageBullet(dots) {
    const items = dots.find('.owl-dot');
    const n = items.length;

    if (n > 0) {
      items.each((index2, i) => {
        const bullet = $(i);
        let current = '';
        if (bullet.hasClass('active')) {
          current = '- Current page';
        }
        bullet.attr('aria-label', `Slide ${index2 + 1} of ${n} ${current}`);
      });
    }
  },
  bulletsContext() {
    setTimeout(() => {
      $('.owl-dots').each((index, e) => {
        const dots = $(e);
        this.calculatePageBullet(dots);
      });
    }, 400);

    // On next item click
    $('.owl-dots button').click((e) => {
      const currentTarget = $(e.currentTarget);
      setTimeout(() => {
        this.calculatePageBullet(currentTarget.parent());
      }, 200);
    });
  },

  carousel2() {
    setTimeout(() => {
      const carouselTop = $('.owl-carousel-2');

      if (carouselTop.find('.owl-nav').length < 2) {
        const clonedObj = carouselTop.find('.owl-nav').eq(0).clone();
        clonedObj.prependTo(carouselTop);
        carouselTop.find('.owl-nav button.owl-next').first().remove();
        carouselTop.find('.owl-nav button.owl-prev').last().remove();
      }
    }, 1000);
  }
};



// WEBPACK FOOTER //
// ./src/app/components/c-cruise-manager/cruise-manager.js